import React, { Component } from 'react';
import { Descriptions, message } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import { COLORS } from '../pages/theme';
import { copyStringToClipboard } from '../lib/util';

const _data= {
    "date": "2019-02-12",
    "value_date": "2019-02-12",
    "tran_particular": "BOALNPKA: 3914621",
    "entry_user_id": "XYZA",
    "vfd_user_id": "XYZA",
    "chq_no": "",
    "tran_remarks": "Electronic Fund Transfer",
    "dr_amount": 0,
    "cr_amount": 4541,
    "balance": 0,
    "source_id": "OFFICE-ACCOUNT-1"
}
class JsonBlockCard extends Component {
  render() {
    let data=this.props.data||{};
    console.log("construction for ",this.props.index)
    let error=this.props.error;
    let success=this.props.success;
    return (
      <div className='default-card hand-cursor'
      onClick={()=>{
        copyStringToClipboard(JSON.stringify(data));
        message.success("Data copied to clipboard")
      }} 
      style={{
          padding:16,
          paddingTop:8,paddingBottom:8,
          backgroundColor:success==true?COLORS.success_secondary:
          error==true?COLORS.danger_secondary:null
      }}>
        {/* <strong>INDEX :  {this.props.index}</strong> */}
        {/* <pre style={{
          marginBottom:0,
          fontSize:12,
          whiteSpace:'pre-wrap'
        }}>
        {JSON.stringify(data,null,this.props.level)}
        </pre> */}
         <Descriptions className='json-description' size='small' layout='horizontal'>
      {Object.keys(data).map((key) => {
              return <Descriptions.Item key={key} label={key} className='log-text' >
                  {/* <Paragraph className='description-paragraph' ellipsis={{ expandable: true, rows: 5 }}> */}
                      {typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key])}
                  {/* </Paragraph> */}
              </Descriptions.Item>
      })}
  </Descriptions>
  </div>
    );
  }
}

export default JsonBlockCard;
